import { render, staticRenderFns } from "./PromotionFormV2.vue?vue&type=template&id=dd48e716&scoped=true"
import script from "./PromotionFormV2.vue?vue&type=script&lang=js"
export * from "./PromotionFormV2.vue?vue&type=script&lang=js"
import style0 from "./PromotionFormV2.vue?vue&type=style&index=0&id=dd48e716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd48e716",
  null
  
)

export default component.exports